import React from "react";
import PropTypes from "prop-types";
import { Box, Container, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import pxToRem from "assets/theme/functions/pxToRem";
import { Colors } from "utils/Constants";
import logo from "assets/images/sidenav_logo.svg";

function LegalLayout({ children }) {
  const handleBack = () => {
    if (window.opener) {
      window.close();
    } else {
      window.location.href = "/authentication/sign-in";
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#F8FAFC",
        display: "flex",
        flexDirection: "column",
        fontFamily: '"Inter", sans-serif',
      }}
    >
      {/* Top Navigation Bar */}
      <Box
        component="header"
        sx={{
          backgroundColor: Colors.WHITE,
          borderBottom: "1px solid #E2E8F0",
          py: 1.5,
          px: { xs: 2, sm: 4, md: 6 },
          position: "sticky",
          top: 0,
          zIndex: 100,
          boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
        }}
      >
        <Box
          sx={{
            maxWidth: "1100px",
            mx: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            component="a"
            href="/authentication/sign-in"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Finvibes"
              sx={{ height: 38, width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Button
            onClick={handleBack}
            startIcon={<ArrowBackIcon sx={{ fontSize: pxToRem(18) }} />}
            sx={{
              textTransform: "none",
              fontSize: pxToRem(13),
              fontWeight: 600,
              color: "#475467",
              backgroundColor: "#F2F4F7",
              borderRadius: "8px",
              px: 2,
              py: 0.8,
              "&:hover": {
                backgroundColor: "#EAECF0",
                color: "#101828",
              },
            }}
          >
            Back to Portal
          </Button>
        </Box>
      </Box>

      {/* Main Content Area */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          py: { xs: 3, sm: 5 },
          px: { xs: 2, sm: 3 },
          maxWidth: "980px !important",
        }}
      >
        {children}
      </Container>

      {/* Subtle Footer */}
      <Box
        component="footer"
        sx={{
          py: 3,
          textAlign: "center",
          borderTop: "1px solid #E2E8F0",
          backgroundColor: Colors.WHITE,
          mt: "auto",
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: pxToRem(12),
            color: "#64748B",
          }}
        >
          © {new Date().getFullYear()} Finvibes Financial Services Pvt. Ltd. All rights reserved.
        </Box>
      </Box>
    </Box>
  );
}

LegalLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LegalLayout;
